import { useQuery } from '@tanstack/react-query'

import { cepIntegrationsKeys } from 'common/api/queryKeys/integrationsKeys'
import { useAppSelector } from 'common/hooks/redux'

import { getIntegrationByIntegrationId } from '../api'

const useGetIntegrationByIdQuery = (integrationId: string | undefined) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const getIntegrationsQuery = useQuery(
    cepIntegrationsKeys.getIntegrationById(integrationId!),
    () =>
      getIntegrationByIntegrationId({
        integrationId: integrationId!,
        accountId,
      }),
    {
      select: (data) => {
        return {
          credentials: data.credentials,
        }
      },
      enabled: !!integrationId,
      cacheTime: 0,
      staleTime: 0,
    }
  )
  return getIntegrationsQuery
}

export default useGetIntegrationByIdQuery
